import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

function NotificationMenuDropdown(props) {
  const dropdownRef = useRef(null);
  const {
    children = null,
    button = null,
    className = 'tv-filter-list__element',
    buttonClass = 'tv-notification_header',
    visible = false,
    setVisible = () => {},
  } = props;

  const topNavigationHandler = () => {
    const elementArray = document.getElementsByClassName(
      'tv-main_layout__container',
    );
    if (elementArray.length === 1) {
      const element = elementArray[0];
      if (visible) {
        element.classList.add('tv-main_layout__container-hidden');
      } else {
        element.classList.remove('tv-main_layout__container-hidden');
      }
    }
  };

  useEffect(() => {
    topNavigationHandler();
  }, [visible]);

  const toggleMenu = () => {
    if (toggleTimeout.current) {
      clearTimeout(toggleTimeout.current);
    }
    toggleTimeout.current = setTimeout(() => {
      setVisible(prevVisible => !prevVisible);
    }, 200);
  };

  const onBlur = event => {
    const { currentTarget } = event;
    setTimeout(() => {
      if (!currentTarget.contains(document.activeElement)) {
        // toggleMenu();
        setVisible(false);
      }
    }, 250);
  };

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape' && visible) {
        setVisible(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [visible]);

  const handleClickOutside = event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setVisible(false);
    }
  };

  useEffect(() => {
    if (visible) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [visible]);

  const toggleTimeout = useRef(null);

  return (
    <div ref={dropdownRef} onBlur={onBlur} className={className}>
      <div
        role="button"
        tabIndex={-1}
        onClick={toggleMenu}
        onKeyDown={() => {}}
        className={buttonClass}
      >
        {button}
      </div>
      {visible && children}
    </div>
  );
}

NotificationMenuDropdown.propTypes = {
  children: PropTypes.node,
  button: PropTypes.node,
  className: PropTypes.string,
  buttonClass: PropTypes.string,
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
};

export default NotificationMenuDropdown;
